import { render } from "./Advantages.vue?vue&type=template&id=1115fdcb&scoped=true"
import script from "./Advantages.vue?vue&type=script&lang=js"
export * from "./Advantages.vue?vue&type=script&lang=js"

import "./Advantages.vue?vue&type=style&index=0&id=1115fdcb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1115fdcb"]])

export default __exports__